import React, { useMemo, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import AdditionDeductionFields from './commonComponents/AdditionDeductionFields'
import { invalidateTotals } from '../../actions'


const AdditionDeductionMechLevel=({className='',invoiceItemIndex,lineItemIndex,index,onUpdate,onSave,disabled,allpropsaa,...rest})=> {
const additions=useSelector(state=>state.DescriptionOfMerchandise?.entrySummaryInvoices[invoiceItemIndex]?.merchandiseLineItems[lineItemIndex]?.merchandiseDuties[index]?.additions)
const deletions=useSelector(state=>state.DescriptionOfMerchandise?.entrySummaryInvoices[invoiceItemIndex]?.merchandiseLineItems[lineItemIndex]?.merchandiseDuties[index]?.deletions)
const grossValue=useSelector(state=>state.DescriptionOfMerchandise?.entrySummaryInvoices[invoiceItemIndex]?.merchandiseLineItems[lineItemIndex]?.merchandiseDuties[index]?.invoiceCurrencyValue)

const merchandiseError = useMemo(() => {
  const errs = [];
  const deductions = Number(deletions?.totalDeletions) || 0;
  const adds = Number(additions?.totalAdditions) || 0;
  const invoiceAmount = Number(grossValue) || 0;
  const calculatedDiff = deductions - adds;

  if (calculatedDiff > invoiceAmount) {
    errs.push("Total deductions cannot be greater than invoice amount.");
  }
  return errs;
}, [additions, deletions, grossValue]);

 const [isLoading,setIsLoading]=useState(false)
 const dispatch=useDispatch()
     const onUpdateData=(value,objectKey,field)=>{
      onUpdate(lineItemIndex,invoiceItemIndex,index,objectKey,field,value.replace(/[^\d.-]/g, ""))
     }
     const onSaveData=(value,objectKey,field,otherData={})=>{
      setIsLoading(true)
      onSave({lineItemIndex,invoiceItemIndex,dutyIndex:index,objectKey,data:{[field]:parseFloat(value || 0.0).toFixed(2),...otherData},allpropsaa},()=>{
        setIsLoading(false)

      })
      if(rest.launchFrom !== 'PRODUCT_HISTORY'){
        dispatch(invalidateTotals())
      }
     }
    const onProrateClick=(objectKey,updatedData,field)=>{
        onSaveData("",objectKey,field,updatedData)
    }
    return (
       <AdditionDeductionFields id={`${lineItemIndex}-${index}`} isLoading={isLoading} {...rest}  onSave={onSaveData} onUpdate={onUpdateData} additions={additions} deletions={deletions} className={className} onProrateClick={onProrateClick} disabled={disabled} 
       errors={{deletions:merchandiseError}}
       />
      
    )
  }
export default AdditionDeductionMechLevel